import { Layout } from 'antd';
import { RoutePaths } from 'core/history';
import { INavigationRouteProps } from 'core/navigation/models';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import './style.less';

const { Content } = Layout;

const FlowDivContainer = styled(Content)`
  background-color: #F5F8FC;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

interface IMarketingPage extends INavigationRouteProps<{}> {
}

export const MarketingPage: React.FC<IMarketingPage> = (props) => {

  useEffect(() => {
    window.location.pathname = RoutePaths.WORKSPACES();
  }, []);

  return (<div/>);
};
